<template>
<div class="mcontainer" v-if="detail!=null">
  <van-nav-bar fixed title="详情" left-text="返回"  left-arrow @click-left="back" />
  <div class="main__body" >
    <div class="article__detail">
      <div class="title">
        <span>{{detail.title}}</span>
      </div>
      <div class="time">
        <span>{{detail.add_time}}</span>
        <!-- <span>{{detail.add_time}}</span> -->
      </div>
      <div class="content">
        <div class="art__content" v-html="detail.ask"></div>
      </div>
    </div>
    <div class="m__title van-hairline--top van-hairline--bottom">解答情况</div>
    <div class="ans__detail">
      <van-empty description="还未解答" v-if="detail.status==0" />
      <div class="content">
        <div class="art__content" v-html="detail.ans"></div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import {
  mapActions
} from 'vuex'
export default {
  components: {},
  data() {
    return {
      detail: null
    }
  },
  props: [],
  computed: {
    id() {
      return this.$route.params.id
    },
    from(){
      return this.$route.query.from
    }
  },
  watch: {},
  created() {
    this.getDetail()
  },
  mounted() {},
  destroyed() {},
  methods: {
    back(){
      if(typeof this.from!='undefined'){
        this.$utils.jump('/?type=3')
      }else{
        this.$utils.back()
      }
    },
    async getDetail() {
      let self = this
      let {
        id
      } = self
      let posData = {
        data: {
          id
        }
      }
      let res = await this._getAskDetail(posData)
      if (res && res.code == 200) {
        self.detail = res.data
      }
    },
    ...mapActions('api', ['_getAskDetail'])
  }
}
</script>
<style lang="less" scoped>
.mcontainer {
    .main__body {
      margin-top: 46px;
      background: #fff;
      min-height: calc(100vh - 46px);
      .content {
          margin-top: 15px;
          .art__content {
              word-break: break-all;
              font-size: 16px;
              line-height: 30px;
          }
      }
        .article__detail {
            padding: 15px 20px;
            box-sizing: border-box;
            .title {
                font-size: 22px;
                font-weight: bold;
                margin-top: 10px;
            }
            .time {
                font-size: 12px;
                margin-top: 8px;
                color: @sub_gray;
                display: flex;
                span{
                  &:first-child{
                    flex:1;
                  }
                }
            }
        }
        .ans__detail{
          padding: 15px 20px;
          box-sizing: border-box;
        }
    }
}
</style>
